module.exports = __webpack_public_path__ + "static/group3_2-5b4c82c9b2aca8c79b400cf763cc1e35.webp";